// extracted by mini-css-extract-plugin
module.exports = {"ReservedMessageWrapper":"OrderPaidMessage-module__ReservedMessageWrapper","btn":"OrderPaidMessage-module__btn"};